import { Spin } from 'antd';

const Spinner = () => {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Spin size="large" tip="Loading...">
        <div style={{ padding: 32 }} />
      </Spin>
    </div>
  );
};

export default Spinner;
